// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteProcurementMethodModel {
    static getAttributeTypeMap() {
        return SiteProcurementMethodModel.attributeTypeMap;
    }
}
SiteProcurementMethodModel.discriminator = undefined;
SiteProcurementMethodModel.attributeTypeMap = [
    {
        "name": "procurementMethodTypeId",
        "baseName": "procurementMethodTypeId",
        "type": "number"
    },
    {
        "name": "procurementMethodTypeCd",
        "baseName": "procurementMethodTypeCd",
        "type": "string"
    },
    {
        "name": "procurementMethodTypeDesc",
        "baseName": "procurementMethodTypeDesc",
        "type": "string"
    }
];
//# sourceMappingURL=siteProcurementMethodModel.js.map